import React, { useEffect, useState, useContext } from 'react';
import './style.css';

import ModalBtn from '../../molecules/modalButton/view';
import Table from '../../molecules/tablas/view';
import ShowThird from '../../organisms/showThird/view';
import { BiShow, BiCheckCircle, BiErrorCircle, BiFile, BiCheck, BiPrinter, BiCopy, BiEdit, BiTrash } from 'react-icons/bi';
import { dispatchCustomEvent } from '../../../utils/dispatch';

function ComprobanteView({ data, profile }) {
    const [comprobante, setComprobante] = useState(null);

    function handleOpen() {
        setComprobante(data)
    }

    function formatAcount(account, code) {
        if (code > 9) {
            return `${account}${code}`
        } else {
            return `${account}0${code}`
        }
    }

    const formatCurrency = (value) => {
        if (!value || Number(value) === 0) return "$ 0";
        return new Intl.NumberFormat('es-CO', {
            style: 'currency',
            currency: 'COP',
            minimumFractionDigits: 0
        }).format(value);
    };

    const calculateTotals = () => {
        if (!comprobante?.lineas) return { debito: 0, credito: 0, balanced: true };
        const debito = comprobante.lineas.reduce((acc, curr) => acc + (Number(curr.valor_debito) || 0), 0);
        const credito = comprobante.lineas.reduce((acc, curr) => acc + (Number(curr.valor_credito) || 0), 0);
        const balanced = Math.abs(debito - credito) < 0.01;
        return { debito, credito, balanced };
    };

    const mapper = (lineas) => {
        return lineas.map((item) => ({
            numero_linea: item.numero_linea,
            third_id: item.tercero_id,
            account: item.users_accounts ? formatAcount(item.users_accounts.account?.account, item.users_accounts.code) : "N/A",
            debito: formatCurrency(item.valor_debito),
            credito: formatCurrency(item.valor_credito),
            description: item.users_accounts?.description || item.users_accounts?.account?.description || item.descripcion || "N/A"
        }))
    }

    const { debito, credito, balanced } = calculateTotals();

    return (
        <ModalBtn
            id={"comprobante" + data?.id}
            width="85vw"
            className='action-btn'
            title={<BiShow />}
            type="action"
            onClick={handleOpen}
        >
            {comprobante ? (
                <div className="comprobante-detail-container">
                    {/* Header Section */}
                    <div className="comprobante-main-header">
                        <div className="comprobante-icon-badge">
                            <BiFile />
                        </div>
                        <div className="comprobante-title-group">
                            <h2>Comprobante #{comprobante.id}</h2>
                            <p className="comprobante-subtitle">Contabilidad General • EasyPos</p>
                        </div>
                    </div>

                    {/* Middle Section: Info & Balance Card */}
                    <div className="comprobante-body-grid">
                        <div className="comprobante-general-info">
                            <div className="info-field-group">
                                <span className="info-label">Descripción</span>
                                <span className="info-value">{comprobante.descripcion || "N/A"}</span>
                            </div>
                            <div className="info-subgrid">
                                <div className="info-field-group">
                                    <span className="info-label">Tipo</span>
                                    <span className="info-value">{comprobante.document_type}</span>
                                </div>
                                <div className="info-field-group">
                                    <span className="info-label">Documento</span>
                                    <span className="info-value">
                                        {comprobante.document} - {comprobante.document_number}
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div className={`balance-card-modern ${balanced ? 'balanced' : 'unbalanced'}`}>
                            <div className="card-header-status">
                                <span className="status-badge">
                                    {balanced ? <><BiCheckCircle /> Estado: Balanceado</> : <><BiErrorCircle /> Estado: Desbalanceado</>}
                                </span>
                                <span className="resumen-label">Resumen de totales</span>
                            </div>
                            <div className="card-totals-grid">
                                <div className="total-col">
                                    <span className="total-label-modern">Total Débito</span>
                                    <span className="total-amount-modern">{formatCurrency(debito)}</span>
                                </div>
                                <div className="total-col">
                                    <span className="total-label-modern">Total Crédito</span>
                                    <span className="total-amount-modern">{formatCurrency(credito)}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Lines Section */}
                    <div className="comprobante-lines-section">
                        <div className="lines-header-row">
                            <h3 className="lines-title-modern">Líneas contables</h3>
                            <div className="lines-actions">
                                <button
                                    className="print-btn-modern"
                                    disabled={false}
                                    onClick={() => {
                                        console.log(comprobante)
                                        dispatchCustomEvent("clone-comprobante-data", comprobante);
                                    }}
                                    style={{ marginRight: '10px' }}
                                >
                                    <BiCopy size={16} /> Clonar
                                </button>
                                <button
                                    className="print-btn-modern"
                                    disabled={false}
                                    onClick={() => {
                                        console.log(comprobante)
                                        dispatchCustomEvent("anular-comprobante-data", comprobante);
                                    }}
                                    style={{ marginRight: '10px' }}
                                >
                                    <BiTrash size={16} /> Anular
                                </button>
                                <button
                                    className="print-btn-modern"
                                    disabled={comprobante.is_manual != 1}
                                    onClick={() => {
                                        dispatchCustomEvent("edit-comprobante-data", comprobante);
                                    }}
                                    style={{ marginRight: '10px', background: 'rgba(59, 130, 246, 0.1)', color: '#3b82f6', border: 'none' }}
                                >
                                    <BiEdit size={16} /> Editar
                                </button>
                                <button
                                    className="print-btn-modern"
                                    onClick={() => {
                                        import('../../../utils/receipt-utils').then(({ printComprobante }) => {
                                            printComprobante(comprobante, profile);
                                        });
                                    }}
                                >
                                    <BiPrinter /> Imprimir
                                </button>
                            </div>
                        </div>

                        {comprobante.lineas && comprobante.lineas.length > 0 ? (
                            <Table
                                maxHeight="40vh"
                                data={mapper(comprobante.lineas)}
                                id="comprobante-lines-table"
                                headersList={["#", "TERCERO", "CUENTA", "DÉBITO", "CRÉDITO", "DESCRIPCIÓN"]}
                                excludeList={["id"]}
                                formats={{
                                    third_id: {
                                        type: "custom",
                                        children: <ShowThird profile={profile} />
                                    }
                                }}
                            />
                        ) : (
                            <p>No hay líneas para este comprobante.</p>
                        )}
                    </div>
                </div>
            ) : (
                <p>Cargando detalles del comprobante...</p>
            )}
        </ModalBtn>
    );
}

export default ComprobanteView;
